import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIosSibche = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={136}
    height={41}
    fill='none'
    {...props}
  >
    <path fill='url(#ios-sibche_svg__a)' d='M.598.017h134.857v40H.598z' />
    <defs>
      <pattern id='ios-sibche_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#ios-sibche_svg__b' transform='scale(.00212 .00714)' />
      </pattern>
      <image
        xlinkHref='/images/icons/ios-sibche-d5f21ba7.webp'
        id='ios-sibche_svg__b'
        width={472}
        height={140}
      />
    </defs>
  </svg>
);
export default SvgIosSibche;
